import {
  GET_LOCATIONS,

} from "../types";
import axios from "axios";
import {firebase} from '../../../firebase/initFirebase'
import moment from 'moment'
import {store} from '../../store'
import { message} from 'antd';

export const getLocations = (props) => {
  return (dispatch) => {
    var reduxState = store.getState()
    var userRole = reduxState.auth.user.role
    var useremail = reduxState.auth.user.email   
    var Firestore = firebase.firestore();
    var dataRef = Firestore.collection('locations') 
      // console.log(props)
      dataRef = dataRef.orderBy("created_at","asc")
      dataRef = dataRef.limit(50)

      dataRef.get()
      .then((documentSnapshots) => {      
          var docs = documentSnapshots.docs
          var lastVisible = documentSnapshots.docs[documentSnapshots.docs.length-1];
          var dataArray =[]
          docs.map(item=>{         
              var newOrder={
                key:item.id,
                id:item.id,
                ...item.data()
              }
              dataArray.push(newOrder)
           
          })

          dispatch({ type: GET_LOCATIONS, payload: {dataArray:dataArray, lastVisible:lastVisible, currentProps:props } })  
          
          
       
      })
      .catch(err=>{
          console.log(err)
      })
  };
};
